import { ulid } from "ulid"

type Args = any
type Type = string
type Response = {
  response?: any
  error?: any
}
type ResponseEvent = {
  data: { id: string; type: string } & Response
}

export class RequestsWorker {
  private requests: any
  private worker: Worker

  constructor(worker: Worker) {
    this.requests = {}
    this.worker = worker
    this.worker.onmessage = (event: ResponseEvent) => {
      const { id, response, error } = event.data

      if (typeof this.requests[id] === "function") {
        this.requests[id]({ response, error })
        delete this.requests[id]
      }
    }
  }

  send({ type, args }: { type: Type; args: Args }) {
    const id = ulid()

    return new Promise((resolve, reject) => {
      this.requests[id] = function onResponse({ response, error }: Response) {
        if (error) {
          reject(error)
          return
        }

        resolve(response)
      }

      this.worker.postMessage({ id, type, args })
    })
  }
}
